import { render, staticRenderFns } from "./PrintInternalFundsTransfer.vue?vue&type=template&id=b51745bc"
import script from "./PrintInternalFundsTransfer.vue?vue&type=script&lang=js"
export * from "./PrintInternalFundsTransfer.vue?vue&type=script&lang=js"
import style0 from "./PrintInternalFundsTransfer.vue?vue&type=style&index=0&id=b51745bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports